import BaseService from '@src/services/BaseService'
import axios from "axios";

class RolesService extends BaseService {
  constructor() {
    super('roles')
  }

  fetchAll(params) {
    return axios.post(`${this.getUrl()}`, params)
  }

  getRoleByName(name) {
    return axios.post(`${this.getUrl()}`, {
        sort: "alias|asc",
        page: 1,
        per_page: 100,
        search: `name:${name}`,
        orderBy: "alias",
        sortedBy: "asc",
    })
  }

  /**
   * Resolve a role by exact `name` (DB column). Repository search uses ilike, so we filter client-side.
   * @param {string} name e.g. 'promotor', 'promotor lider', 'supervisor'
   * @returns {Promise<object|null>}
   */
  async findRoleByExactName(name) {
    const res = await this.getRoleByName(name)
    const rows = res?.data?.data || []
    return rows.find((r) => r.name === name) || null
  }

  getPermissions(id, params) {
    return this.axios.post(`${this.getUrl()}/${id}/get-permissions`);
  }

  batchAssignPermissionsToRole(id, params) {
    return this.axios.post(`${this.getUrl()}/${id}/batch-assign`, params);
  }

}

export default new RolesService()
